import React from 'react';

import styled from 'styled-components';

import { CommunityAdminListType } from 'types/communities';

const Container = styled.span`
  display: flex;
  flex-direction: column;
  margin: 2px 0px 10px 0px;
`;

const Main = styled.span`
  font-size: 14px;
  color: var(--text-primary);
`;

const Secondary = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

interface Props {
  item: CommunityAdminListType;
}

const CommunitiesTableAddress = ({ item }: Props) => {
  const address = item?.address;
  const [street, city, stateZip, country] = address.split(',').map((s: string) => s.trim());
  const [state, zip] = (stateZip ?? '').split(' ').map((s: string) => s.trim());

  return (
    <Container>
      <Main>{street}</Main>
      <Secondary>
        {[zip ?? item?.zip, city ?? item?.city, state ?? item?.state].filter((item: string) => !!item).join(', ')}
      </Secondary>
    </Container>
  );
};

export default CommunitiesTableAddress;
